import type { ReactNode } from 'react';
import Markdown from 'markdown-to-jsx';
import {
  Modal,
  ModalContent,
  ModalContentHeader,
  ModalContentBody,
  ModalContentFooter,
} from '../../display/Modal';
import { LegacyButton } from '../../navigation/LegacyButton';
import styles from './PolicyModal.module.scss';

type Props = {
  /** Title of the policy. */
  title: string;
  /** A description of what's changed in the policy. */
  tldr: string;
  /** URL of the policy page to view more. */
  url?: string;
  /** Callback for when acceptance button is clicked. */
  onAccept: () => void;
  /** Function to render markdown. */
  renderMarkdown?: (markdown: string) => ReactNode;
};

/** A `Modal` component for displaying policies to review and accept. */
export const PolicyModal = ({
  onAccept,
  title,
  tldr,
  url,
  renderMarkdown = (markdown: string) => <Markdown>{markdown}</Markdown>,
}: Props) => {
  return (
    <Modal canClose={false} onClosed={() => {}}>
      <ModalContent maxWidth="70ch">
        <ModalContentHeader>
          <h1 data-zds className={styles.title}>
            We’ve updated the {title}
          </h1>
        </ModalContentHeader>
        <ModalContentBody scrollable={true}>
          <div className={styles.markdown} data-zds>
            {renderMarkdown(tldr)}
          </div>
        </ModalContentBody>
        <ModalContentFooter>
          {!!url && (
            <LegacyButton color="secondary" href={url} target="_blank">
              Review changes
            </LegacyButton>
          )}
          <LegacyButton color="primary" hasShadow={true} onClick={onAccept}>
            Accept
          </LegacyButton>
        </ModalContentFooter>
      </ModalContent>
    </Modal>
  );
};
